<div class="trackDragHandle" cdkDragHandle></div>
<canvas #canvas (window:resize)="onResize()"></canvas>